import { render } from "./Speed050.vue?vue&type=template&id=5db9ea41"
import script from "./Speed050.vue?vue&type=script&lang=js"
export * from "./Speed050.vue?vue&type=script&lang=js"
script.render = render

export default script